import { TestimonialItem } from '@src/pages/LandingPage/Testimonials'

// Curated customer reviews shown on the junk-removal service pages
// (mattress, furniture, appliance, piano, tv/electronics, yard debris, junk).
const junkTestimonials: Array<TestimonialItem> = [
  {
    name: 'Jessica',
    comment:
      'Very easy to schedule. They removed all items completely and on time. We would use them again.',
  },
  {
    name: 'Joanne',
    comment: 'Everything was great, prompt, efficient and professional.',
  },
  {
    name: 'Marshall',
    comment:
      'Easy to set up, nice price and great service from the trash removal workers! Very pleased and will use this service again.',
  },
]

export default junkTestimonials
